const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
const WEB_URL = process.env.NEXT_PUBLIC_WEB_URL;
const GEOLOCATION_URL = process.env.NEXT_PUBLIC_GEOLOCATION_URL;
const STRAPI_API_URL = process.env.NEXT_PUBLIC_STRAPI_API_URL;
const STRAPI_BASE_URL = process.env.NEXT_PUBLIC_STRAPI_BASE_URL;
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
const DISCORD_URL = process.env.NEXT_DISCORD_URL;
const KYC_MODULE_STATUS = process.env.NEXT_PUBLIC_KYC_ENABLED;
const DISPLAY_SONG_PAGE = process.env.NEXT_PUBLIC_DISPLAY_SONG_PAGE;
const CACHED_API_URL = process.env.NEXT_PUBLIC_CACHED_API_URL;
const FANTV_API_URL = process.env.NEXT_PUBLIC_FANTV_API_URL;

export {
  RECAPTCHA_SITE_KEY,
  WEB_URL,
  GEOLOCATION_URL,
  STRAPI_API_URL,
  STRAPI_BASE_URL,
  API_BASE_URL,
  DISCORD_URL,
  KYC_MODULE_STATUS,
  DISPLAY_SONG_PAGE,
  CACHED_API_URL,
  FANTV_API_URL,
};
